/**
 * Full-page skeleton loader shown while initial data is being fetched.
 * Prevents template "flash" — the real page only renders once data is ready.
 */
export default function PageSkeleton({ variant = 'list' }: { variant?: 'list' | 'detail' | 'cards' | 'grid' }) {
  if (variant === 'detail') {
    return (
      <div className="space-y-6 animate-in fade-in">
        <div className="skeleton h-8 w-48" />
        <div className="card card-body space-y-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="flex gap-4">
              <div className="skeleton h-4 w-32" />
              <div className="skeleton h-4 flex-1" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (variant === 'cards') {
    return (
      <div className="space-y-6 animate-in fade-in">
        <div className="flex items-center justify-between">
          <div className="skeleton h-8 w-48" />
          <div className="skeleton h-10 w-32 rounded-lg" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="card card-body space-y-4">
              <div className="skeleton h-5 w-24" />
              <div className="skeleton h-10 w-32" />
              <div className="space-y-2">
                {Array.from({ length: 4 }).map((_, j) => (
                  <div key={j} className="skeleton h-3 w-full" />
                ))}
              </div>
              <div className="skeleton h-10 w-full rounded-lg" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (variant === 'grid') {
    return (
      <div className="space-y-6 animate-in fade-in">
        <div className="skeleton h-8 w-48" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="card card-body space-y-3">
              <div className="skeleton h-5 w-32" />
              <div className="skeleton h-8 w-24" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Default: list/table
  return (
    <div className="space-y-6 animate-in fade-in">
      <div className="flex items-center justify-between">
        <div className="skeleton h-8 w-48" />
        <div className="skeleton h-10 w-32 rounded-lg" />
      </div>
      <div className="card overflow-hidden">
        <table className="table w-full">
          <thead>
            <tr>
              {Array.from({ length: 6 }).map((_, j) => (
                <th key={j}><div className="skeleton h-3 w-16" /></th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 8 }).map((_, i) => (
              <tr key={i}>
                {Array.from({ length: 6 }).map((_, j) => (
                  <td key={j}><div className="skeleton h-4 w-20" /></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
